<template>
  <div class="flex mt-6 flex-wrap lg:">

    <div class="w-full md:w-1/3 py-2 px-0 md:px-6">
      <label
        class="font-semibold"
        for=""
      >{{ $t('messages.step_one.year') }}</label>
      <select
        :class="['select', true ? 'is-danger' : '']"
        class="h-12 mt-4 block border-blue-500 font-semibold text-gray-700 border rounded w-full pl-6 bg-white appearance-none focus:outline-none custom-select"
        v-model="year"
        :data-vv-scope="formScope"
        :data-vv-as="$t('messages.step_one.year')"
        name="year"
        v-validate="'required'"
        @change="onChangeYear"
      >
        <option
          v-for="(year, index) in years"
          :value="year"
          :key="index"
        >{{year}}</option>
      </select>
      <ul>
        <li
          v-for="(error, index) in errors.collect(`${formScope}.year`)"
          :key="index"
          class="text-sm text-red-500 font-semibold mt-2 is-danger"
        >
          {{ error }}
        </li>
      </ul>
    </div>
    <div class="w-full md:w-1/3 py-2 px-0">
      <label
        class="font-semibold"
        for=""
      >{{ $t('messages.step_one.month') }}</label>
      <select
        :class="['select', true ? 'is-danger' : '']"
        class="h-12 mt-4 block border-blue-500 font-semibold text-gray-700 border rounded w-full pl-6 bg-white appearance-none focus:outline-none custom-select"
        v-model="month"
        :data-vv-scope="formScope"
        :data-vv-as="$t('messages.step_one.month')"
        name="month"
        v-validate="'required'"
        @change="onChangeMonth"
      >
        <option
          v-for="(month, index) in months"
          :value="month"
          :key="index"
        >{{ $t(`messages.months.${index}`) }}</option>
      </select>
      <ul>
        <li
          v-for="(error, index) in errors.collect(`${formScope}.month`)"
          :key="index"
          class="text-sm text-red-500 font-semibold mt-2 is-danger"
        >
          {{ error }}
        </li>
      </ul>
    </div>
    <div class="w-full md:w-1/3 py-2 px-0 md:px-6">
      <label
        class="font-semibold"
        for=""
      >{{ $t('messages.step_one.day') }}</label>
      <select
        :class="['select', true ? 'is-danger' : '']"
        class="h-12 mt-4 block border-blue-500 font-semibold text-gray-700 border rounded w-full pl-6 bg-white appearance-none focus:outline-none custom-select"
        v-model="day"
        :data-vv-scope="formScope"
        :data-vv-as="$t('messages.step_one.day')"
        name="day"
        v-validate="'required'"
        @change="onChangeDay"
      >
        <option
          v-for="(day, index) in days"
          :value="day"
          :key="index"
        >{{day}}</option>
      </select>
      <ul>
        <li
          v-for="(error, index) in errors.collect(`${formScope}.day`)"
          :key="index"
          class="text-sm text-red-500 font-semibold mt-2 is-danger"
        >
          {{ error }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "date-picker",
  props: {
    format: {
      type: String,
      default: "YYYYMMDD"
    },
    start: {
      type: String,
      default: "19000101"
    },
    default: {
      type: String,
      default: "19900101"
    },
    end: {
      type: String,
      default: "20201231"
    },
    vvscope: {
      type: String,
      default: ""
    },
    isEmpty: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      form: {},
      year: "",
      month: "",
      day: "",
      years: [],
      months: [],
      days: [],
      startDate: null,
      endDate: null,
      formScope: ""
    };
  },
  computed: {
    date: {
      get: function() {
        return moment({
          year: this.year,
          month: this.month,
          day: this.day
        });
      },
      set: function(v) {
        var _d = null;
        if (moment.isMoment(v)) {
          _d = v;
        } else {
          _d = moment(v, this.format);
        }
        if (!_d.isValid()) {
          throw new Error(
            "Not valid moment or not valid time for format: ",
            this.format
          );
        }

        this.year = this.isEmpty ? '' : _d.year();
        this.month = this.isEmpty ? '' : _d.month();
        this.day = this.isEmpty ? '' : _d.date();
      }
    }
  },
  created() {
    var _s = moment(this.start, this.format);
    if (!_s.isValid()) {
      throw new Error("Start date is not right, or format is not right.");
    }
    var _d = moment(this.default, this.format);
    if (!_d.isValid()) {
      throw new Error("Default date is not right, or format is not right.");
    }
    var _e = moment(this.end, this.format);
    if (!_e.isValid()) {
      throw new Error("End date is not right, or format is not right.");
    }
    if (!_s.isBefore(_e)) {
      throw new Error("Start date must before end date.");
    }
    if (!_d.isBetween(_s, _e)) {
      throw new Error("Default date must between start and end.");
    }
    this.startDate = { year: _s.year(), month: _s.month(), day: _s.date() };
    this.endDate = { year: _e.year(), month: _e.month(), day: _e.date() };
    this.date = _d;
    this.formScope = this.vvscope;
    this.getYears();
    this.getMonths();
    this.getDays();
    this.$emit("changeDate", this.date);
  },
  methods: {
    moment: function() {
      return moment();
    },
    getYears: function() {
      var _to = this.endDate.year;
      for (var _y = this.startDate.year; _y <= _to; _y++) {
        this.years.push(_y);
      }

      this.years = this.years.reverse();
    },
    getMonths: function() {
      this.months = [];
      //if (this.year === "") return;
      var _to = 11;
      var _m = 0;
      if (this.year >= this.endDate.year) {
        _to = this.endDate.month;
      }
      if (this.year <= this.startDate.year) {
        _m = this.startDate.month;
      }
      for (; _m <= _to; _m++) {
        this.months.push(_m);
      }
    },
    getDays: function() {
      this.days = [];
      //if (this.year === "" || this.month === "") return;
      let  _to = this.month === "" ? 31 : moment({ year: this.year, month: this.month }).daysInMonth();
      var _d = 1;
      if (
        this.year <= this.startDate.year &&
        this.month <= this.startDate.month
      ) {
        _d = this.startDate.day;
      }
      if (this.year >= this.endDate.year && this.month >= this.endDate.month) {
        _to = this.endDate.day;
      }
      for (; _d <= _to; _d++) {
        this.days.push(_d);
      }
    },
    async onChangeYear() {
      this.month = "";
      this.day = "";
      this.getMonths();
      this.getDays();

      this.$emit("changeDate", this.date);
    },
    onChangeMonth: function() {
      this.day = "";
      this.getDays();
      this.$emit("changeDate", this.date);
    },
    onChangeDay: function() {
      this.$emit("changeDate", this.date);
    }
  },
  watch: {
    default(date) {
      this.date =  moment(date, this.format);
    }
  }
};
</script>
